import VueJwtDecode from 'vue-jwt-decode'
import moment from 'moment'

export const users = {
    namespaced: true,
    state: {
        status: 'loggedOut',
        token: null,
        email: ''
    },
    mutations: {
        SET_STATUS(state, status) {
            state.status = status
        },
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_EMAIL(state, email) {
            state.email = email
        }
    },
    actions: {
        login({ state, commit, getters, dispatch }, payload) {
            commit('SET_STATUS', 'pending')
            return this.$api
                .post(
                    'client/v2/users/login',
                    {
                        email: payload.email,
                        password_hash: payload.password
                        // long_time: 1
                    },
                    {
                        'Content-Type': 'multipart/form-data'
                    }
                )
                .then(response => {
                    if (response.status === 200) {
                        commit('SET_TOKEN', response.data.data.token)
                        commit('SET_STATUS', 'loggedIn')
                        this.$storage.setItem('userEmail', payload.email)
                        return this.$storage
                            .setItem(
                                'authToken',
                                response.data.data.access_token.token
                            )
                            .catch(error => {
                                return Promise.reject(new Error(error))
                            })
                    } else {
                        return Promise.reject(new Error(response))
                    }
                })
                .catch(error => {
                    commit('SET_STATUS', 'loggedOut')
                    return Promise.reject(new Error(error))
                })
        },
        logout({ commit }) {
            // remove session on server
            this.$storage
                .removeItem('authToken')
                .then(() => {
                    // remove from store
                    commit('SET_STATUS', 'loggedOut')
                    this.$storage
                        .getItem('initialState')
                        .then(initialState => {
                            if (initialState !== null) {
                                // replace state with initial state after e.g logout
                                this.replaceState(initialState)
                            } else {
                                window.location.reload()
                            }
                        })
                        .catch(error => {
                            console.error(error)
                        })
                })
                .catch(error => {
                    console.error(error)
                })
        },
        checkTokenValidity({ commit, dispatch }) {
            return dispatch('loadToken').then(token => {
                // check if there is auth data in storage
                if (token !== null && token !== undefined) {
                    // check token validity
                    if (moment(VueJwtDecode.decode(token).exp, 'X').isAfter()) {
                        commit('SET_STATUS', 'loggedIn')
                        return token
                    }
                    return Promise.reject(new Error('Token expired'))
                }
                return false
            })
        },
        async getUserId({ dispatch }) {
            const token = await dispatch('checkTokenValidity')
            if (token) {
                const decoded = VueJwtDecode.decode(token)
                if ('sub' in decoded) {
                    return decoded.sub
                }
                return Promise.reject(new Error('Invalid JWT token'))
            }
            return false
        },
        loadToken({ commit }) {
            return this.$storage.getItem('authToken').then(token => {
                commit('SET_TOKEN', token)
                return token
            })
        },
        resetPasswordStep1({ state, commit }, payload) {
            commit('SET_STATUS', 'pending')
            return this.$api
                .post('client/v2/users/request-password-reset', payload, {
                    'Content-Type': 'application/json'
                })
                .then(response => {
                    commit('SET_STATUS', 'loggedOut')
                    if (response.status === 200) {
                        return response.data.data.info
                    } else {
                        return Promise.reject(new Error(response.data.message))
                    }
                })
                .catch(error => {
                    commit('SET_STATUS', 'loggedOut')
                    return Promise.reject(error)
                })
        },
        resetPasswordStep2({ state, commit }, payload) {
            commit('SET_STATUS', 'pending')
            return this.$api
                .post('client/v2/users/password-reset', payload, {
                    'Content-Type': 'multipart/form-data'
                })
                .then(response => {
                    commit('SET_STATUS', 'loggedOut')
                    if (response.status === 200) {
                        return response.data.data.info
                    } else {
                        return Promise.reject(new Error(response.data.message))
                    }
                })
                .catch(error => {
                    commit('SET_STATUS', 'loggedOut')
                    return Promise.reject(error)
                })
        },
        renewPassword({ state, commit }, payload) {
            commit('SET_STATUS', 'pending')
            return this.$api
                .post('client/v2/users/renew-password', payload, {
                    'Content-Type': 'multipart/form-data'
                })
                .then(response => {
                    commit('SET_STATUS', 'loggedOut')
                    if (response.status === 200) {
                        return response.data.data.info
                    } else {
                        return Promise.reject(new Error(response.data.message))
                    }
                })
                .catch(error => {
                    commit('SET_STATUS', 'loggedOut')
                    return Promise.reject(error)
                })
        },
        signup({ state, commit }, payload) {
            commit('SET_STATUS', 'pending')
            return this.$api
                .post('client/v2/users/signup', payload, {
                    'Content-Type': 'multipart/form-data'
                })
                .then(response => {
                    commit('SET_STATUS', 'loggedOut')
                    return response
                })
                .catch(error => {
                    commit('SET_STATUS', 'loggedOut')
                    return Promise.reject(error)
                })
        },
        extendSession({ commit }) {
            return this.$api
                .get('client/v2/users/alive')
                .then(response => {
                    if (response.status === 200) {
                        commit('SET_TOKEN', response.data.access_token.token)
                    }
                })
                .catch(error => {
                    return Promise.reject(error)
                })
        },
        setEmail({ commit }) {
            this.$storage
                .getItem('userEmail')
                .then(response => {
                    commit('SET_EMAIL', response)
                })
                .catch(error => {
                    return Promise.reject(error)
                })
        }
    },
    getters: {
        status: state => state.status,
        token: state => state.token,
        email: state => state.email
    }
}
